import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-48f9b74f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "my-2 flex justify-center text-[#6B6B6B]"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " New Conversation ", -1))
const _hoisted_3 = {
  key: 1,
  class: "sticky top-0 z-10 flex w-full justify-between"
}

import {
  PhNotePencil,
  PhSidebar,
} from '@phosphor-icons/vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatNavigation',
  setup(__props) {


const conversationHistoryStore = useStore.conversationHistory;
const conversationThreadStore = useStore.conversationThread;
const utilStore = useStore.util;

function handleShowHistoryList(): void {
  conversationHistoryStore.showHistoryList = true;
  utilStore.isSupportOn = false;
  utilStore.supportId = -1;
}

function onClickNewConversation(): void {
  utilStore.isSupportOn = false;
  utilStore.supportId = -1;

  conversationHistoryStore.showHistoryList = false;
  utilStore.isSupportOn = false;
  conversationThreadStore.messages = [];
  conversationThreadStore.uuid = '';
}


return (_ctx: any,_cache: any) => {
  return (_unref(conversationHistoryStore).showHistoryList)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "btn flex gap-2 rounded-lg border-gray-400 bg-[#F8F8F8] px-4 py-2 shadow-md hover:bg-blue-1 hover:text-white",
          onClick: onClickNewConversation
        }, [
          _createVNode(_unref(PhNotePencil), { size: 24 }),
          _hoisted_2
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "history-list-btn",
          onClick: handleShowHistoryList
        }, [
          _createVNode(_unref(PhSidebar), {
            size: 28,
            class: "opacity-75"
          })
        ]),
        (_unref(conversationThreadStore).uuid || _unref(utilStore).isSupportOn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "create-new-btn",
              onClick: onClickNewConversation
            }, [
              _createVNode(_unref(PhNotePencil), {
                size: 28,
                class: "opacity-75"
              })
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})